import { Vue, Component, toNative } from 'vue-facing-decorator';
import AppSettingTable from 'components/AppSettingTable/';
import Template from './template.vue';

@Component({
	components: {
		AppSettingTable,
	},
	mixins: [Template],
})
class AppSetting extends Vue {
	protected showModal(): void {
		this.$root?.$emit(
			'bv::show::modal',
			'appsetting-modal',
			'#showBtn',
		);
	}
}

export default toNative(AppSetting);
